<script setup lang="ts">
import { Label } from "reka-ui";
import { useField } from "vee-validate";

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(
  defineProps<{
    class?: string;
    label: string;
    name: string;
    type?: string;
    disabled?: boolean;
  }>(),
  {
    type: "text",
  }
);

const { value, errorMessage } = useField<string>(props.name);
</script>

<template>
  <div :class="class">
    <div
      class="relative rounded-lg text-text-primary"
      :class="disabled ? 'text-text-primary/40' : null"
    >
      <Label
        class="absolute top-2 left-4 text-xs pointer-events-none"
        :for="name"
      >
        {{ label }}
      </Label>
      <input
        class="bg-background-secondary pb-2 pt-7 px-4 w-full rounded-lg"
        :id="name"
        :type="type"
        :name="name"
        :disabled="disabled"
        v-model="value"
        v-bind="$attrs"
      />
    </div>
    <transition>
      <div v-if="errorMessage" class="text-error text-sm mt-1">
        {{ errorMessage }}
      </div>
    </transition>
  </div>
</template>
